.delete-report-btn{border:none}.delete-report-btn:disabled{opacity:.3!important;cursor:not-allowed!important;pointer-events:all!important}
/*# sourceMappingURL=phones-reports-table-actions.component-DQ6KAPPC.css.map */
